import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Stack, TextField } from "@mui/material";
import { customPaymentExport, fileImport, sampleFile } from "../apiService";
import { globalExportService, globalPostService } from "../../../utils/globalApiServices";
import { checkApiStatus, downloadFileType, numberWithCommas } from "../../../utils";
import { enqueueSnackbar } from "notistack";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { backendDateFormat, fieldDateFormat } from "../../../constants";
import { regexConstants } from "../../../constants/regEx";
import { isMobile } from "react-device-detect";
import { trackActivity } from "../../../utils/mixpanel";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { ButtonLoader } from "../../../shared_elements/components";
import { exportToExcel } from '../../../utils/helper';

const PaymentScheduleTable = ({ leaseSlug, data, onFieldChange, errors = [], onRestCustomPaymentFieldError, modeType,onImportBackup }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);
    const [isExport, setExport] = useState(false);

    useEffect(() => {
        if (data?.custom_payments?.length) {
            setRows(data.custom_payments);
        }
    }, [data?.custom_payments]);

    const handleImportClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        event.target.value = null;
        const formData = new FormData();
        formData.append("file", file);
        setLoading(true);
        globalPostService(fileImport({ leaseSlug }), formData)
            .then((response) => {
                const fileData = response?.data?.data;
                const expectedKeys = ['period', 'payment_date', 'rent', 'basic_rent', 'reference_value'];
                const actualKeys = Object.keys(fileData?.[0] || {});
                const hasAllExpectedKeys = expectedKeys.every(key => actualKeys.includes(key));
                if (!hasAllExpectedKeys) {
                    enqueueSnackbar( 'Unable to import the file. Missing required fields. Please ensure the file matches the expected format.', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } } );
                    setRows([]);
                    return;
                }
                if (fileData?.length === 0) {
                    enqueueSnackbar("Kindly import the data which contains data", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    return
                }
                if (Array.isArray(fileData)) {
                    const updatedData = fileData?.map((item) => ({
                        ...item,
                        period: parseInt(item.period || 0)
                    }));
                    onImportBackup(updatedData)
                    setRows(updatedData);
                    enqueueSnackbar("Imported successfully!", { variant: "success" });
                    onFieldChange("custom_payments", fileData);
                } else {
                    enqueueSnackbar("Invalid file content", { variant: "error" });
                }
            })
        setLoading(false);
    };

    const handleExport = () => {
        setExport(true);
        globalExportService(customPaymentExport(leaseSlug,data?.slug))
            .then((response) => {
                if (checkApiStatus) {
                    downloadFileType(response?.data, `${data?.name}_custom_payment_${moment().format(backendDateFormat)}.`, "xlsx");
                    setExport(false);
                }
                setExport(false);
            })

    };

    const downlodSampleFile = () => {
        setLoading(true);
        globalExportService(sampleFile())
            .then((response) => {
                downloadFileType(response?.data, `payment_schedule_sample_${moment().format(backendDateFormat)}.`, "xlsx");
                setLoading(false);
            })
        setLoading(false);
    };

    // const syncToParent = (updated) => {
    //     setRows(updated);
    //     onFieldChange("custom_payments", updated);
    // };

    const handleChange = (index, key, value) => {
        const updatedRows = [...(data?.custom_payments || [])];
        updatedRows[index][key] = value;
        onFieldChange("custom_payments", updatedRows);
    };

    // const handleDeleteRow = (index) => {
    //     const updated = rows.filter((_, i) => i !== index);
    //     syncToParent(updated);
    // };
const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Custom Table`, page_type: page_type, })
    }
    return (
        <Box sx={{ width: "100%" }} className="escalation-container">
            <Box className="escalation-box">
                <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} justifyContent="space-between" spacing={2} sx={{marginBottom: "5px"}}>
                    <Typography className="section-header-text">
                        Payment Schedule:{" "}
                        <Typography variant="body2" onClick={() => { downlodSampleFile(); handleItemClicked('Download Sample File') }} sx={{ cursor: "pointer", color: "blue", textDecoration: "underline", fontWeight: "normal", display: "inline", }} component="span" > Download Sample File </Typography>
                    </Typography>
                    <Stack direction="row" spacing={1}  sx={{mb: 1}}>
                        {modeType !== 'view' ?
                            <Button size="small" variant="outlined" onClick={() => { handleImportClick(); handleItemClicked('Import Button') }}>
                                IMPORT
                            </Button> : null}
                        <Button size="small" variant="outlined" disabled={!data?.custom_payments?.length} startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => {
                            exportToExcel({
                                data: data?.custom_payments,
                                fileName: `${data?.name ? data.name + "_" :""}payment_schedule_${moment().format(backendDateFormat)}.`,
                                sheetName: `Payment Shedule Table"`,
                                columns: {
                                    "Calculation Period": (row) => (row?.period === '' || row?.period === null || row?.period === undefined) ? "" : row.period,
                                    "Payment Date": (row) =>  row.payment_date ? moment(row.payment_date).format("DD-MM-YYYY") : null,
                                    "Rent": (row) => (row?.rent === '' || row?.rent === null || row?.rent === undefined) ? "" : Number(row.rent),
                                    "Basic Rent": (row) => (row?.basic_rent === '' || row?.basic_rent === null || row?.basic_rent === undefined) ? "" : Number(row.basic_rent),
                                    "Reference Value":  (row) => (row?.reference_value === '' || row?.reference_value === null || row?.reference_value === undefined) ? "" : Number(row.reference_value),
                                }
                            })
                            // handleExport()
                                ; handleItemClicked('Export Button')
                        }} > EXPORT </Button>
                    </Stack>
                </Stack>
                <input type="file" accept=".xlsx" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
                <TableContainer className="lease-detail-table" component={Paper}>
                    <Table className="mui-table-format">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{minWidth: isMobile ? "140px" : null}}>Calculation Period</TableCell>
                                <TableCell sx={{minWidth: isMobile ? "140px" : null}}>Payment Date</TableCell>
                                <TableCell sx={{minWidth: isMobile ? "140px" : null}}>Rent</TableCell>
                                <TableCell sx={{minWidth: isMobile ? "140px" : null}}>Basic Rent</TableCell>
                                <TableCell sx={{minWidth: isMobile ? "140px" : null}}>Reference Value</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows?.length > 0 ? (
                                rows.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <TextField
                                                value={row.period ?? ''}
                                                size="small"
                                                onChange={(e) => {regexConstants.decimalnodotstart.test(e.target.value) ? handleChange(index, "period", e.target.value) : e.preventDefault() }}
                                                error={!!errors?.[index]?.period}
                                                helperText={errors?.[index]?.period}
                                                onFocus={() => onRestCustomPaymentFieldError(index, "period")} 
                                                disabled={ modeType === 'view' }
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DatePicker
                                                    value={row.payment_date ? moment(row.payment_date) : null}
                                                    onChange={(value) => { handleChange(index, "payment_date", moment(value).isValid() ? moment(value).format(backendDateFormat) : null); onRestCustomPaymentFieldError?.(index, "payment_date"); }}
                                                    slotProps={{
                                                        textField: {
                                                            size: "small",
                                                            InputLabelProps: { shrink: true },
                                                            error: errors?.[index]?.payment_date || false,
                                                            helperText: errors?.[index]?.payment_date || '',
                                                        },
                                                        field: {
                                                            clearable: true,
                                                            onClear: () => handleChange(index, "payment_date", null),
                                                        },
                                                    }}
                                                    sx={{ width: "100%" }}
                                                    format={fieldDateFormat}
                                                    disabled={ modeType === 'view' }
                                                />
                                            </LocalizationProvider>
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={modeType === 'view' && row.rent !== '' && row.rent !== null && row.rent !== undefined ? numberWithCommas(row.rent) : (row.rent ?? '')}
                                                size="small"
                                                onChange={(e) => {regexConstants.decimalnodotstart.test(e.target.value) ? handleChange(index, "rent", e.target.value):e.preventDefault() }}
                                                error={!!errors?.[index]?.rent}
                                                helperText={errors?.[index]?.rent}
                                                onFocus={() => onRestCustomPaymentFieldError(index, "rent")} 
                                                disabled={ modeType === 'view' }
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={modeType === 'view' && row.basic_rent !== '' && row.basic_rent !== null && row.basic_rent !== undefined ? numberWithCommas(row.basic_rent) : (row.basic_rent ?? '')}
                                                size="small"
                                                onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? handleChange(index, "basic_rent", e.target.value):e.preventDefault() }}
                                                error={!!errors?.[index]?.basic_rent}
                                                helperText={errors?.[index]?.basic_rent}
                                                onFocus={() => onRestCustomPaymentFieldError(index, "basic_rent")} 
                                                disabled={ modeType === 'view' }
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                value={modeType === 'view' && row.reference_value !== '' && row.reference_value !== null && row.reference_value !== undefined ? numberWithCommas(row.reference_value) : (row.reference_value ?? '')}
                                                size="small"
                                                onChange={(e) => {regexConstants.decimalnodotstart.test(e.target.value) ? handleChange(index, "reference_value", e.target.value):e.preventDefault() }}
                                                error={!!errors?.[index]?.reference_value}
                                                helperText={errors?.[index]?.reference_value}
                                                onFocus={() => onRestCustomPaymentFieldError(index, "reference_value")}
                                                disabled={ modeType === 'view' } 
                                            />
                                        </TableCell>
                                        {/* <TableCell align="center">
                                            <IconButton onClick={() => handleDeleteRow(index)} color="error">
                                                <DeleteOutline />
                                            </IconButton>
                                        </TableCell> */}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        No Data Found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

export default PaymentScheduleTable;